import { EnvelopeIcon } from '@heroicons/react/24/outline';
import Button from 'common/components/Button/Button';
import SectionTitle from 'common/components/SectionTitle/SectionTitle';
import ProfileBadges from 'components/ProfileBadges/ProfileBadges';
import { useTranslation } from 'react-i18next';
import { Operator } from 'types/Operator';
import { Profile } from 'types/Profile';

function ProfileCard({
  profile,
  title = 'Profile',
  noTitle = false,
  onClick: handleClick = null,
  userEmail = null,
  canAddProfile = false,
}: {
  profile: Profile | Operator;
  title?: string;
  noTitle?: boolean;
  onClick?: null | (() => void);
  canAddProfile?: boolean;
  userEmail?: string | null;
}) {
  const { t } = useTranslation();
  return (
    <>
      {!noTitle && <SectionTitle title={title} icon="UserIcon" className="text-fourth" />}
      <div
        className={`responsive-flex flex-row gap-6 p-1 overflow-hidden ${
          handleClick && profile
            ? 'cursor-pointer border-white hover:border-slate-200 hover:bg-slate-50 border rounded-md'
            : ''
        }`}
        onClick={() => {
          if (handleClick && profile) {
            handleClick();
          }
        }}
      >
        <div className="grid flex-1">
          {profile ? (
            <>
              <div className="flex flex-row justify-between flex-wrap items-center flex-1">
                <div className="font-bold text-xl">{profile?.username}</div>
                <ProfileBadges profile={profile} classname="self-justify-end" />
              </div>
              <div className="flex flex-row justify-start flex-wrap items-center flex-1 gap-4">
                <div className="font-bold text-md">
                  {profile?.firstname} {profile?.lastname}
                </div>
              </div>
            </>
          ) : (
            <div className="flex flex-row justify-between flex-wrap items-center flex-1">
              <div className="text-md italic opacity-70">{t('titleLegends.noProfile')}</div>
              {canAddProfile && (
                <Button
                  type="purple-line"
                  title={t('actions.addInformations')}
                  onClick={() => {
                    if (handleClick) {
                      handleClick();
                    }
                  }}
                />
              )}
            </div>
          )}

          {userEmail && (
            <div className="flex items-center gap-1 text-sm">
              <EnvelopeIcon className="w-4 h-4" />
              <span className="text-md font-bold">{userEmail}</span>
            </div>
          )}
        </div>
      </div>
    </>
  );
}

export default ProfileCard;
